///////////////////////////////////////////////////////
// Fetches data from API and renders template
// based on properties passed from router.
// Also handles loading meta data per template.
///////////////////////////////////////////////////////

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import queryString from 'qs';

import AsyncChunks from '../../utilities/AsyncLoader';
import canUseDom from '../../../utilities/canUseDom';
// import Footer from '../../layout/Footer';
import api from '../../../api';
// import globalCss from '../../../global.css';
// import styled from 'styled-components';
import Footer from '../../layout/Footer';

const AsyncDefault = AsyncChunks.generateChunk(() => 
	import( /* webpackChunkName: "Default" */ '../Default'));

const AsyncHome = AsyncChunks.generateChunk(() => 
	import( /* webpackChunkName: "Home" */ '../Home'));

const AsyncContact = AsyncChunks.generateChunk(() => 
	import( /* webpackChunkName: "Contact" */ '../Contact'));

const AsyncPost = AsyncChunks.generateChunk(() => 
	import( /* webpackChunkName: "Post" */ '../Post'));

const AsyncShow = AsyncChunks.generateChunk(() => 
	import( /* webpackChunkName: "Show" */ '../Show'));

const AsyncShows = AsyncChunks.generateChunk(() => 
	import( /* webpackChunkName: "Shows" */ '../Shows'));

const AsyncTeam = AsyncChunks.generateChunk(() => 
	import( /* webpackChunkName: "Team" */ '../Team'));

const templates = {
	home: AsyncHome,
	contact: AsyncContact,
	default: AsyncDefault,
	post: AsyncPost,
	show: AsyncShow,
	gallery: AsyncShows,
	team: AsyncTeam
}

const mapStateToProps = state => ({
	data: state.api.data
});

const mapDispatchToProps = dispatch => ({
	load: (data) => dispatch({ type: 'LOAD_DATA_BY_SLUG', payload: data })
});

class LoadTemplate extends Component {

	constructor(props) {
		super(props);
		// console.log(this.props);

		this.scrollProgress = 0;
		this.state = {
			preview: false,

			// Slug will either come from a prop or a URL param from Router
			// Necessary because some slugs come from URL params
			slug: this.props.slug 
				? this.props.slug 
				: this.props.match.params.slug
		}

		this.fetchData();
	}

	checkForPreview() {
		if (canUseDom) {
			let params = [];

			params = queryString.parse(
				window.location.search,
				{ ignoreQueryPrefix: true }
			);

			if (params.preview === 'true' && params['_wpnonce']) {
				api.Content.previewDataBySlug( this.props.type, this.state.slug, params['_wpnonce']).then(
					res => {
						this.setState({ preview: res })
					},
					error => {
						console.warn(error);
						this.props.history.push('/not-found');
					}
				);
			} 
		}
	}

	fetchData() {
		// added check that props.data actually exists and that key above slug (props.type) exists first:
		if (this.props.data && this.props.data[this.props.type] && !this.props.data[this.props.type][this.state.slug]) {
			// Load page content from API by slug
			api.Content.dataBySlug(this.props.type, this.state.slug).then(
				res => {
					this.props.load({
						type: this.props.type,
						slug: this.state.slug,
						data: res
					})
				},
				error => {
					console.warn(error);
				}
			);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.slug !== this.props.match.params.slug) {
			this.setState({
				slug: this.props.match.params.slug
			})
		}
	}

	render() {
// console.log(this.props);

		
		this.checkForPreview();

		let data = this.state.preview;
		
		if (!this.state.preview && this.props.data[this.props.type] && this.props.data[this.props.type][this.state.slug]) {
			data = this.props.data[this.props.type][this.state.slug];
		}

		let Meta = () => null;

		const Template = templates[this.props.template];

		if (!Template) {
			return <Redirect to="/not-found"/>;
		}

		const metaTitle = data && data.seo && data.seo.meta_title ? data.seo.meta_title : '';
		const metaDesc =  data && data.seo && data.seo.meta_desc ? data.seo.meta_desc: '';
		const ogTitle =  data && data.seo && data.seo.og_title ? data.seo.og_title: '';
		const ogDesc =  data && data.seo && data.seo.og_desc ? data.seo.og_desc: '';
		const ogImg =  data && data.seo && data.seo.og_img ? data.seo.og_img: '';
		if (data) {
			Meta = () => {
				return (
					<Helmet>
						<title>{metaTitle}</title>
						<meta name="description" content={metaDesc} />
						<meta property="og:site_name" content="Mirrad" />
						<meta property="og:locale" content="en_GB" />
						<meta property="og:title" content={ogTitle} />
						<meta property="description" content={ogDesc} />
						<meta property="og:type" content="website" />
						<meta property="og:image" content={ogImg} />
						<meta name="twitter:site" content="@mirradinfo" />
						<meta name="robots" content="index, follow" />
						{/* <meta name="keywords" content={data.acf.metaKeywords} /> */}
						{/* <style type="text/css" dangerouslySetInnerHTML={ globalCss } */}
						
					</Helmet>
				)
			}
		}
		
		const Foot = () => {
			if (this.props.template !== 'default') {
				
				return (
					<Footer location={this.props.location.pathname} />
				)
			} else {				
				return null;
			}
		}

		return (
			<div className={"template-wrap " + this.state.slug + ' ' + data.type + ' template-' + this.props.template}>
				<Meta />
				<Template data={data} slug={this.state.slug} />
				<Foot />
			</div>

		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadTemplate);



// WEBPACK FOOTER //
// ./src/components/templates/LoadTemplate/index.js